// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__6AOdU","wrapper":"UserMenu_wrapper__Mqh7H"};